var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentDeletedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F76565"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22H20.25C20.25 21.5858 20.5858 21.25 21 21.25V22ZM25.7071 24.2929L26.2374 24.8232L25.7071 24.2929ZM23.2929 26.7071L22.7626 26.1768L23.2929 26.7071ZM16 26.25H21V27.75H16V26.25ZM25 13.75H16V12.25H25V13.75ZM15.75 14V26H14.25V14H15.75ZM25.25 22V14H26.75V22H25.25ZM26 22.75H21V21.25H26V22.75ZM21.75 22V27H20.25V22H21.75ZM25.25 23.5858V22H26.75V23.5858H25.25ZM21 26.25H22.5858V27.75H21V26.25ZM22.7626 26.1768L25.1768 23.7626L26.2374 24.8232L23.8232 27.2374L22.7626 26.1768ZM26.75 23.5858C26.75 24.0499 26.5656 24.495 26.2374 24.8232L25.1768 23.7626C25.2237 23.7157 25.25 23.6521 25.25 23.5858H26.75ZM16 13.75C15.8619 13.75 15.75 13.8619 15.75 14H14.25C14.25 13.0335 15.0335 12.25 16 12.25V13.75ZM22.5858 26.25C22.6521 26.25 22.7157 26.2237 22.7626 26.1768L23.8232 27.2374C23.495 27.5656 23.0499 27.75 22.5858 27.75V26.25ZM25 12.25C25.9665 12.25 26.75 13.0335 26.75 14H25.25C25.25 13.8619 25.1381 13.75 25 13.75V12.25ZM16 27.75C15.0335 27.75 14.25 26.9665 14.25 26H15.75C15.75 26.1381 15.8619 26.25 16 26.25V27.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 24V24.75H11.25V24H12.75ZM23 9.25C23.4142 9.25 23.75 9.58579 23.75 10C23.75 10.4142 23.4142 10.75 23 10.75V9.25ZM11.25 24V11H12.75V24H11.25ZM13 9.25H23V10.75H13V9.25ZM11.25 11C11.25 10.0335 12.0335 9.25 13 9.25V10.75C12.8619 10.75 12.75 10.8619 12.75 11H11.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDeletedIcon);
export default __webpack_public_path__ + "static/media/document-deleted-icon.35beb7b1.svg";
export { ForwardRef as ReactComponent };